module.exports = __webpack_public_path__ + "static/media/词法分析).27a0d41f.png";